import { gql } from "apollo-boost";

const UPDATE_ORDER_NOTE = gql`
  mutation updateOrderNote($input: UpdateOrderNote) {
    updateOrderNote(input: $input) {
      status
      error
      data
    }
  }
`;

export default UPDATE_ORDER_NOTE;
